export default __webpack_public_path__ + "static/media/background.4191a2ef.webp";